export default __webpack_public_path__ + "critical_services.png";